import { DeliveryType, Order } from 'orderme-api-integration-client';
import { store } from '../redux/store';

const isOnlyPhysicalItems = (order: Order): boolean => {
  const deliveryServiceIds = getDeliveryServices();
  return order.items.filter((item) => !deliveryServiceIds.includes(item.serviceId)).every((item) => item.isItem);
};

const getDeliveryType = (order: Order) => {
  if (order.destination?.parcelLocker) {
    return DeliveryType.ForeignLocker;
  }

  if (!order.destination.knownId) {
    return DeliveryType.Address;
  }

  return DeliveryType.SalesPoint;
};

const getDeliveryServices = () => store.getState().settingsState.deliveryServiceIds;

const OrderHelper = {
  isOnlyPhysicalItems,
  getDeliveryType,
};

export default OrderHelper;
